import TopNav from "@/pages/home/components/TopNav";
import HeroSection from "@/pages/home/components/HeroSection";
import NewsTicker from "@/pages/home/components/NewsTicker";
import HotBoard from "@/pages/home/components/HotBoard";
import CategoryStream from "@/pages/home/components/CategoryStream";
import TrustSection from "@/pages/home/components/TrustSection";
import CommunityTalk from "@/pages/home/components/CommunityTalk";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import SiteFooter from "@/pages/home/components/SiteFooter";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopNav />
      <main className="w-full">
        <HeroSection />
        <NewsTicker />
        <HotBoard />
        <CategoryStream />
        <CommunityTalk />
        <TrustSection />
        <FaqSection />
        <SubscribeCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}